import { graphql, useStaticQuery } from 'gatsby';
import React, { FC, useContext } from 'react';

import InformedConsentStep, {
	IInformedConsentStepPageContent,
} from '@ui/routes/shared/InformedConsentStep';

import { keysToCamel } from '@utils/butter';

import FlowContext from '@providers/FlowContextProvider';

import { IFlowStepProps } from '@folx-types/flow-steps';

interface IInformedConsentStepPageProps extends IFlowStepProps {}

const InformedConsentStepPage: FC<IInformedConsentStepPageProps> = ({ path, stepKey }) => {
	const { pageContent } = useStaticQuery(graphql`
		{
			pageContent: butterPage(slug: { eq: "hrt-e-informed-consent-step" }) {
				page_header
				terms_title
				terms_content
				terms_fine_print
				terms_agree_label
				benefits_title
				benefits {
					item_title
					item_details
				}
				risks_title
				risks {
					item_title
					item_details
				}
				alternatives_title
				alternatives {
					item_title
					item_details
				}
				download_copy_content
				learn_more_content
			}
		}
	`);

	const refinedContent = keysToCamel(pageContent) as IInformedConsentStepPageContent;

	const { existingFormData, handleFormSubmission, handleNavBack } = useContext(FlowContext);

	return (
		<InformedConsentStep
			path={path}
			stepKey={stepKey}
			pageContent={refinedContent}
			existingFormData={existingFormData}
			handleFormSubmission={handleFormSubmission}
			handleNavBack={handleNavBack}
		/>
	);
};

export default InformedConsentStepPage;
